import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CampaignTrackingService } from '../services/campaign-tracking.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignGuard implements CanActivate {

  constructor(
    private campaignTrackingService: CampaignTrackingService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // Always capture campaign_id if present
    this.campaignTrackingService.captureCampaignId();
    
    // For account-related routes, preserve campaign_id in URL
    if (this.isAccountRoute(state.url)) {
      return this.handleAccountRoute(route, state);
    }
    
    return true;
  }

  private isAccountRoute(url: string): boolean {
    const accountRoutes = ['/account'];
    return accountRoutes.some(route => url.includes(route));
  }

  private handleAccountRoute(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const campaignId = this.campaignTrackingService.getLatestCampaignId();
    const currentCampaignId = route.queryParams['campaign_id'];
    
    if (campaignId && !currentCampaignId) {
      // Redirect to the same route with campaign_id parameter
      const urlTree = this.router.parseUrl(state.url);
      urlTree.queryParams = { ...urlTree.queryParams, campaign_id: campaignId };
      
      this.router.navigateByUrl(urlTree);
      return false;
    }
    
    return true;
  }
}